class AfsBlock {
    readonly container: string
    readonly numberOfAfs: number
    readonly isTop: boolean
    readonly width: string = "100%"

    constructor(container: string, numberOfAfs: number, isTop: boolean) {
        this.container = container;
        this.numberOfAfs = numberOfAfs;
        this.isTop = isTop;
    }

    public toPlainObject() {
        return this.isTop ? this.topParams() : this.bottomParams();
    }

    private bottomParams() {
        return {
            ...{
                container: this.container,
                number: this.numberOfAfs,
                width: this.width,
            },
            ...this.extraParams()
        };
    }

    private topParams() {
        return {
            ...{
                container: this.container,
                maxTop: this.numberOfAfs,
                width: this.width,
            },
            ...this.extraParams()
        }
    }

    private extraParams() {
        return {
            colorBackground: "#FFFFFF",
            fontSizeTitle: "16px",
            fontSizeDescription: "13px",
            fontSizeDomainLink: "13px",
            colorTitleLink: "#2200C1",
            colorText: "#666",
            colorDomainLink: "#327c50",
            colorBorder: "#ffffff",
            noTitleUnderline: true,
        }
    }
}

export default AfsBlock
